<template>
  <div class="ordercenter">
    <div class="page-title">
      <div class="page-title-wrap">
        <div>订单中心</div>
        <div class="search-wrap">
          <input class="icon-text" type="test" v-model="search_value" placeholder="请输入需求名称">
          <i class="icon-serch" @click="handleSearch"></i>
        </div>
      </div>
    </div>
    <div class="nav-tabpanel-box">
      <div :class="['item-nav-box', selTabIndex == 100001 ? 'active' : '']" @click="handleSelTab(100001)">
        投标任务
      </div>
      <div :class="['item-nav-box', selTabIndex == 200002 ? 'active' : '']" @click="handleSelTab(200002)">
        宣传任务
      </div>
      <div :class="['item-nav-box', selTabIndex == 300003 ? 'active' : '']" @click="handleSelTab(300003)">
        征集需求
      </div>
      <div :class="['item-nav-box', selTabIndex == 400004 ? 'active' : '']" @click="handleSelTab(400004)">
        UI需求
      </div>
      <div :class="['item-nav-box', selTabIndex == 500005 ? 'active' : '']" @click="handleSelTab(500005)">
        测试需求
      </div>
    </div>
    <template v-if="selTabIndex == 100001">
      <div class="table-header-box recharge cell-row">
        <div class="cell-column offername">任务名称</div>
        <div class="cell-column offertype">审核状态</div>
        <div class="cell-column offermoney">报价金额</div>
        <div class="cell-column offertime">最新提交时间</div>
        <div class="cell-column offerHandle">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row">
          <div class="offer-num-box ">
            <div>报价编号：<span class="order-num">{{ item.id_public_middle_table }}</span></div>
            <el-upload
              v-if="item.mid_table_remark_009==9003"
              action="no"
              accept=".png,.jpg,.jpeg"
              :auto-upload="false"
              :multiple="false"
              :show-file-list="false"
              :on-change="
                (file, fileList) => {
                  handleUpload(file, fileList, idx);
                }
              "
            >
              <div class="upload-code">上传支付宝收款码</div>
            </el-upload>
          </div>
          <div class="cell-row">
            <div class="cell-column offername">{{ item.mid_table_remark_005 }}</div>
            <template v-if="item.mid_table_remark_007==7001">
              <div class="cell-column offertype color9002">竞标中</div>
            </template>
            <div
              v-else-if="item.mid_table_remark_007==7002"
              class="cell-column offertype"
              :class="item.mid_table_remark_009?'color'+item.mid_table_remark_009:'color9001'"
            >
              {{ item.mid_table_remark_009==9002?'审核中':(item.mid_table_remark_009==9003?'已通过':(item.mid_table_remark_009==9004?'未通过':'未提交')) }}
            </div>
            <template v-if="item.mid_table_remark_007==7003">
              <div class="cell-column offertype gray">已失效</div>
            </template>
            <div class="cell-column offermoney">{{ item.mid_table_remark_006 }}</div>
            <div class="cell-column offertime">{{ item.time_4_begin||'--' }}</div>
            <div class="cell-column offerHandle">
              <div class="handleItem width85 red" @click="downloadTaskZip(idx)">需求包下载</div>
              <template v-if="item.mid_table_remark_007==7002">
                <div
                  class="handleItem width85"
                  :class="item.mid_table_remark_011?'red':'pink'"
                  @click="downloadReviewZip(idx)"
                >
                  任务包下载
                </div>
                <div v-if="item.mid_table_remark_009==9003||item.mid_table_remark_009==9004" class="handleItem width85 pink">任务包上传</div>
                <el-upload
                  v-else
                  action="no"
                  accept=".zip"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="
                    (file, fileList) => {
                      handleChange(file, fileList, idx);
                    }
                  "
                >
                  <div class="handleItem width85 red">任务包上传</div>
                </el-upload>
              </template>
              <div v-if="item.mid_table_remark_007==7001" class="handleItem width40 red" @click="revoke(idx)">撤销报价</div>
              <template v-else-if="item.mid_table_remark_007==7002">
                <div v-if="!item.mid_table_remark_009||item.mid_table_remark_009==9001" class="handleItem width40 red" @click="revokeAll(idx)">撤销中标</div>
                <div v-else class="handleItem width40 pink">撤销中标</div>
              </template>
              <div v-else class="handleItem width40 pink">撤销报价</div>
            </div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 200002">
      <div class="table-header-box recharge cell-row">
        <div class="cell-column offername">任务名称</div>
        <div class="cell-column offertype">审核状态</div>
        <div class="cell-column offermoney">报价金额</div>
        <div class="cell-column offertime">最新提交时间</div>
        <div class="cell-column offerHandle">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row">
          <div class="offer-num-box ">
            <div>报价编号：<span class="order-num">{{ item.id_public_middle_table }}</span></div>
          </div>
          <div class="cell-row">
            <div class="cell-column offername">{{ item.mid_table_remark_001 }}</div>
            <template v-if="item.mid_table_remark_018==1801">
              <div class="cell-column offertype color9002">竞标中</div>
            </template>
            <div
              v-else-if="item.mid_table_remark_018==1802"
              class="cell-column offertype"
              :class="item.mid_table_remark_021?'color'+item.mid_table_remark_021:'color2101'"
            >
              {{ item.mid_table_remark_021==2102?'审核中':(item.mid_table_remark_021==2103?'已通过':(item.mid_table_remark_021==2104?'未通过':'未提交')) }}
            </div>
            <template v-if="item.mid_table_remark_018==1803">
              <div class="cell-column offertype gray">已取消</div>
            </template>
            <div class="cell-column offermoney">{{ item.mid_table_remark_017 }}</div>
            <div class="cell-column offertime">{{ item.time_4_begin||'--' }}</div>
            <div class="cell-column offerHandle">
              <div class="handleItem width100 red" @click="downloadPublicityZip(idx)">任务文件下载</div>
              <template v-if="item.mid_table_remark_018==1802">
                <div
                  class="handleItem width85"
                  :class="item.mid_table_remark_020?'red':'pink'"
                  @click="downloadPublicityReviewZip(idx)"
                >
                  文件下载
                </div>
                <div v-if="item.mid_table_remark_021==2103||item.mid_table_remark_021==2104" class="handleItem width85 pink">上传文件</div>
                <el-upload
                  v-else
                  action="no"
                  accept=".zip"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="
                    (file, fileList) => {
                      handlePublicityChange(file, fileList, idx);
                    }
                  "
                >
                  <div class="handleItem width85 red">上传文件</div>
                </el-upload>
              </template>
              <div v-if="item.mid_table_remark_018==1801" class="handleItem width40 red" @click="revokePublicity(idx)">撤销报价</div>
              <template v-else-if="item.mid_table_remark_018==1802">
                <div v-if="!item.mid_table_remark_021||item.mid_table_remark_021==2101" class="handleItem width40 red" @click="revokePublicity(idx)">撤销中标</div>
                <div v-else class="handleItem width40 pink">撤销中标</div>
              </template>
              <div v-else class="handleItem width40 pink">撤销报价</div>
            </div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 300003">
      <div class="table-header-box recharge cell-row">
        <div class="cell-column offername">征集需求名称</div>
        <div class="cell-column offermoney">审核状态</div>
        <div class="cell-column offertype">报价金额</div>
        <div class="cell-column collectHandle">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row">
          <div class="offer-num-box ">
            <div>报价编号：<span class="order-num">{{ item.id_public_middle_table }}</span></div>
            <el-upload
              v-if="item.mid_table_remark_017==1705"
              action="no"
              accept=".png,.jpg,.jpeg"
              :auto-upload="false"
              :multiple="false"
              :show-file-list="false"
              :on-change="
                (file, fileList) => {
                  handleUploadCode(file, fileList, idx);
                }
              "
            >
              <div class="upload-code">上传支付宝收款码</div>
            </el-upload>
          </div>
          <div class="cell-row">
            <div class="cell-column offername">{{ item.mid_table_remark_001 }}</div>
            <template v-if="item.mid_table_remark_013==1301">
              <div class="cell-column offertype color9002">竞标中</div>
            </template>
            <template v-else-if="item.mid_table_remark_013==1302">
              <div class="cell-column offertype" :class="item.mid_table_remark_021?'color'+item.mid_table_remark_021:'color2101'">
                {{ item.mid_table_remark_017==1702?'草图待审核':(item.mid_table_remark_017==1703?'代码待提交':(item.mid_table_remark_017==1704?'代码待审核':(item.mid_table_remark_017==1705?'已通过':(item.mid_table_remark_017==1706?'未通过':'未提交')))) }}
              </div>
            </template>
            <template v-else-if="item.mid_table_remark_013==1303">
              <div class="cell-column offertype gray">已取消</div>
            </template>
            <div class="cell-column offermoney">{{ item.mid_table_remark_012 }}</div>
            <div class="cell-column collectHandle">
              <div class="handleItem width120 red" @click="downloadDemandZip(idx)">样本文件下载</div>
              <template v-if="item.mid_table_remark_013==1302">
                <template v-if="item.mid_table_remark_017==1702">
                  <div
                    class="handleItem width120"
                    :class="item.mid_table_remark_015?'red':'pink'"
                    @click="downloadDemandDraftZip(idx)"
                  >
                    草图文件下载
                  </div>
                  <el-upload
                    action="no"
                    accept=".zip"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="
                      (file, fileList) => {
                        handleDraftChange(file, fileList, idx);
                      }
                    "
                  >
                    <div class="handleItem width120 red">上传草图文件</div>
                  </el-upload>
                  <div class="handleItem width120 red" @click="revokeDemandAll(idx)">撤销中标</div>
                </template>
                <template v-else-if="item.mid_table_remark_017==1703">
                  <div
                    class="handleItem width120"
                    :class="item.mid_table_remark_015?'red':'pink'"
                    @click="downloadDemandDraftZip(idx)"
                  >
                    草图文件下载
                  </div>
                  <el-upload
                    action="no"
                    accept=".zip"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="
                      (file, fileList) => {
                        handleDemandCodeChange(file, fileList, idx);
                      }
                    "
                  >
                    <div class="handleItem width120 red">上传代码文件</div>
                  </el-upload>
                  <div class="handleItem width120 red" @click="revokeDemandAll(idx)">撤销中标</div>
                </template>
                <template v-else-if="item.mid_table_remark_017==1704">
                  <div
                    class="handleItem width120"
                    :class="item.mid_table_remark_016?'red':'pink'"
                    @click="downloadDemandCodeZip(idx)"
                  >
                    代码文件下载
                  </div>
                  <el-upload
                    action="no"
                    accept=".zip"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="
                      (file, fileList) => {
                        handleDemandCodeChange(file, fileList, idx);
                      }
                    "
                  >
                    <div class="handleItem width120 red">上传代码文件</div>
                  </el-upload>
                  <div class="handleItem width120 red" @click="revokeDemandAll(idx)">撤销中标</div>
                </template>
                <template v-else-if="item.mid_table_remark_017==1705">
                  <div
                    class="handleItem width120"
                    :class="item.mid_table_remark_016?'red':'pink'"
                    @click="downloadDemandCodeZip(idx,1001)"
                  >
                    代码文件下载
                  </div>
                </template>
                <template v-else-if="item.mid_table_remark_017==1706"></template>
                <template v-else>
                  <div
                    class="handleItem width120"
                    :class="item.mid_table_remark_015?'red':'pink'"
                    @click="downloadDemandDraftZip(idx)"
                  >
                    草图文件下载
                  </div>
                  <el-upload
                    action="no"
                    accept=".zip"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="
                      (file, fileList) => {
                        handleDraftChange(file, fileList, idx);
                      }
                    "
                  >
                    <div class="handleItem width120 red">上传草图文件</div>
                  </el-upload>
                  <div class="handleItem width120 red" @click="revokeDemandOffer(idx)">撤销报价</div>
                </template>
              </template>
              <div v-else-if="item.mid_table_remark_013==1301" class="handleItem width120 red" @click="revokeDemandOffer(idx)">撤销报价</div>
            </div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 400004">
      <div class="table-header-box recharge cell-row">
        <div class="cell-column offername">UI需求名称</div>
        <div class="cell-column offermoney">审核状态</div>
        <div class="cell-column offertype">报价金额</div>
        <div class="cell-column collectHandle">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row">
          <div class="offer-num-box">
            <div>报价编号：<span class="order-num">{{ item.id_public_middle_table }}</span></div>
            <div class="offer-content-box">
              <el-upload
                v-if="item.mid_table_remark_016==1603"
                action="no"
                accept=".png,.jpg,.jpeg"
                :auto-upload="false"
                :multiple="false"
                :show-file-list="false"
                :on-change="
                  (file, fileList) => {
                    handleUploadUICode(file, fileList, idx);
                  }
                "
              >
                <div class="upload-code">上传支付宝收款码</div>
              </el-upload>
              <el-tooltip
                v-if="item.mid_table_remark_013==1302"
                placement="bottom"
                :enterable="true"
                popper-class="code-custom-tooltip"
                effect="light"
              >
                <div slot="content" class="code-tooltip-inner">
                  <div class="code-tooltip-inner-title">入群二维码</div>
                  <div class="code-tooltip-inner-img-wrap">
                    <el-image
                      class="code-tooltip-inner-img"
                      :src="codeurl"
                      :fit="fit">
                    </el-image>
                  </div>
                </div>
                <div class="upload-code">入群二维码</div>
              </el-tooltip>
            </div>
          </div>
          <div class="cell-row">
            <div class="cell-column offername">{{ item.mid_table_remark_001 }}</div>
            <template v-if="item.mid_table_remark_013==1301">
              <div class="cell-column offertype color9002">竞标中</div>
            </template>
            <template v-else-if="item.mid_table_remark_013==1302">
              <div class="cell-column offertype">
                {{ item.mid_table_remark_016==1602?'待审核':(item.mid_table_remark_016==1603?'已通过':(item.mid_table_remark_016==1604?'未通过':'未提交')) }}
             </div>
            </template>
            <template v-else-if="item.mid_table_remark_013==1303">
              <div class="cell-column offertype gray">已取消</div>
            </template>
            <div class="cell-column offermoney">{{ item.mid_table_remark_012 }}</div>
            <div class="cell-column collectHandle">
              <div class="handleItem width120 red" @click="downloadUIDemandZip(idx)">UI需求文档</div>
              <template v-if="item.mid_table_remark_013==1302">
                <template v-if="item.mid_table_remark_016==1602">
                  <div
                    class="handleItem width120"
                    :class="item.mid_table_remark_015?'red':'pink'"
                    @click="downloadUIFinishZip(idx)"
                  >
                    设计稿文件下载
                  </div>
                  <el-upload
                    action="no"
                    accept=".zip"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="
                      (file, fileList) => {
                        handleUIChange(file, fileList, idx);
                      }
                    "
                  >
                    <div class="handleItem width120 red">上传设计稿文件</div>
                  </el-upload>
                  <div class="handleItem width120 red" @click="revokeUIDemandAll(idx)">撤销中标</div>
                </template>
                <template v-else-if="item.mid_table_remark_016==1603">
                  <div
                    class="handleItem width120"
                    :class="item.mid_table_remark_015?'red':'pink'"
                    @click="downloadUIFinishZip(idx)"
                  >
                    设计稿文件下载
                  </div>
                </template>
                <template v-else-if="item.mid_table_remark_016==1604"></template>
                <template v-else>
                  <div
                    class="handleItem width120"
                    :class="item.mid_table_remark_015?'red':'pink'"
                    @click="downloadUIFinishZip(idx)"
                  >
                    设计稿文件下载
                  </div>
                  <el-upload
                    action="no"
                    accept=".zip"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="
                      (file, fileList) => {
                        handleUIChange(file, fileList, idx);
                      }
                    "
                  >
                    <div class="handleItem width120 red">上传设计稿文件</div>
                  </el-upload>
                  <div class="handleItem width120 red" @click="revokeUIDemandAll(idx)">撤销中标</div>
                </template>
              </template>
              <div v-else-if="item.mid_table_remark_013==1301" class="handleItem width120 red" @click="revokeUIDemandOffer(idx)">撤销报价</div>
            </div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 500005">
      <div class="table-header-box recharge cell-row">
        <div class="cell-column offername">测试需求名称</div>
        <div class="cell-column offermoney">审核状态</div>
        <div class="cell-column offertype">报价金额</div>
        <div class="cell-column collectHandle">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row">
          <div class="offer-num-box">
            <div>报价编号：<span class="order-num">{{ item.id_public_middle_table }}</span></div>
            <div class="offer-content-box">
              <el-upload
                v-if="item.mid_table_remark_016==1603"
                action="no"
                accept=".png,.jpg,.jpeg"
                :auto-upload="false"
                :multiple="false"
                :show-file-list="false"
                :on-change="
                  (file, fileList) => {
                    handleUploadUICode(file, fileList, idx);
                  }
                "
              >
                <div class="upload-code">上传支付宝收款码</div>
              </el-upload>
              <el-tooltip
                v-if="item.mid_table_remark_013==1302"
                placement="bottom"
                :enterable="true"
                popper-class="code-custom-tooltip"
                effect="light"
              >
                <div slot="content" class="code-tooltip-inner">
                  <div class="code-tooltip-inner-title">入群二维码</div>
                  <div class="code-tooltip-inner-img-wrap">
                    <el-image
                      class="code-tooltip-inner-img"
                      :src="testCodeurl"
                      :fit="fit">
                    </el-image>
                  </div>
                </div>
                <div class="upload-code">入群二维码</div>
              </el-tooltip>
            </div>
          </div>
          <div class="cell-row">
            <div class="cell-column offername">{{ item.mid_table_remark_001 }}</div>
            <template v-if="item.mid_table_remark_013==1301">
              <div class="cell-column offertype color9002">竞标中</div>
            </template>
            <template v-else-if="item.mid_table_remark_013==1302">
              <div class="cell-column offertype">
                {{ item.mid_table_remark_016==1602?'待审核':(item.mid_table_remark_016==1603?'已通过':(item.mid_table_remark_016==1604?'未通过':'未提交')) }}
             </div>
            </template>
            <template v-else-if="item.mid_table_remark_013==1303">
              <div class="cell-column offertype gray">已取消</div>
            </template>
            <div class="cell-column offermoney">{{ item.mid_table_remark_012 }}</div>
            <div class="cell-column collectHandle">
              <div class="handleItem width120 red" @click="downloadTestDemandZip(idx)">测试需求文档</div>
              <template v-if="item.mid_table_remark_013==1302">
                <template v-if="item.mid_table_remark_016==1602">
                  <div class="handleItem width120 red" @click="revokeTestDemandAll(idx)">撤销中标</div>
                </template>
              </template>
              <div v-else-if="item.mid_table_remark_013==1301" class="handleItem width120 red" @click="revokeTestDemandOffer(idx)">撤销报价</div>
            </div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
  </div>
</template>
<script>
import { Base64 } from "js-base64";
import NoneData from "@/components/NoneData";
import pageCommon from "@/utils/pagecommon";
import taskApi from "@/api/task";
import publicityApi from "@/api/publicity";
import demandCollectApi from "@/api/demandCollect";
import UIDemandApi from "@/api/UIDemand";
import testDemandApi from "@/api/testDemand";
import { formatDate } from "@/utils/tool";
export default {
  name: "OrderCenter",
  components: {NoneData},
  created() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 2);
    _this.selTabIndex=100001;
    if(_this.selTabIndex==100001){
      }else{
        _this.getOrderList();
      }
  },
  mounted() {
    let _this = this;
  },
  data() {
    return {
      rechargeList: [],
      projectList: [],
      distributionList: [],
      selTabIndex: 100001,
      orderList:[],
      currentPage:1,
      pageSize:10,
      disabledLoadMore:false,
      codeurl:'',
      testCodeurl:'',
      fit:'cover',
      old_search_value:'',
      search_value:'',
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  mounted: function () {
  },
  filters: {
  },
  methods: {
    handleSearch(){
      let _this = this;
      if(_this.search_value!=_this.old_search_value){
        _this.old_search_value=_this.search_value;
        _this.currentPage=1;
        _this.orderList=[];
        if(_this.selTabIndex==100001){
          _this.getGotList();
        }else if(_this.selTabIndex==200002){
          _this.getOrderList();
        }else if(_this.selTabIndex==300003){
          _this.getDemandList();
        }else if(_this.selTabIndex==400004){
          _this.getUIDemandList();
        }else if(_this.selTabIndex==500005){
          _this.getTestDemandList();
        }
      }
    },
    handleSelTab: function (idx) {
      let _this = this;
      if (_this.selTabIndex == idx) {
        return;
      }
      _this.selTabIndex = idx;
      _this.currentPage=1;
      _this.orderList=[];
      if(_this.selTabIndex==100001){
        _this.getGotList();
      }else if(_this.selTabIndex==200002){
        _this.getOrderList();
      }else if(_this.selTabIndex==300003){
        _this.getDemandList();
      }else if(_this.selTabIndex==400004){
        _this.getUIDemandList();
      }else if(_this.selTabIndex==500005){
        _this.getTestDemandList();
      }
    },
    getGotList: function () {
      let _this = this;
      let requestTaskData = {
        isloading: true,
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        mid_table_remark_005:this.search_value,
        mid_table_remark_007:'7002,7001,7003',
        id_public_user_info: _this.userInfo.id_public_user_info,
        is_online:'0,1',
        pre_db_para_order_by_para:' id_public_middle_table desc '
      };
      pageCommon.apiRequestCommon(taskApi, "getOfferData", requestTaskData).then(
        (res) => {
          _this.agentInfo = res.self_public_agent_info;
          _this.codeurl=_this.agentInfo.agent_remark_010;
          _this.testCodeurl=_this.agentInfo.agent_remark_012;
          let orderList = res.page_content;
          if (orderList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          _this.orderList.push(...orderList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          _this.isRequesting = false;
          _this.orderList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    getOrderList: function () {
      let _this = this;
      let requestTaskData = {
        isloading: true,
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        mid_table_remark_001:this.search_value,
        mid_table_remark_018:'1802,1801,1803',
        id_public_user_info: _this.userInfo.id_public_user_info,
        is_online:'0,1'
      };
      pageCommon.apiRequestCommon(publicityApi, "getPublicityOfferData", requestTaskData).then(
        (res) => {
          _this.agentInfo = res.self_public_agent_info;
          _this.codeurl=_this.agentInfo.agent_remark_010;
          _this.testCodeurl=_this.agentInfo.agent_remark_012;
          let orderList = res.page_content;
          if (orderList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          _this.orderList.push(...orderList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          console.log(err)
          _this.isRequesting = false;
          _this.orderList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    getDemandList: function () {
      let _this = this;
      let requestTaskData = {
        isloading: true,
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        mid_table_remark_001:this.search_value,
        mid_table_remark_013:'1301,1302,1303',
        id_public_user_info: _this.userInfo.id_public_user_info,
        is_online:'0,1',
        pre_db_para_order_by_para:' id_public_middle_table desc '
      };
      pageCommon.apiRequestCommon(demandCollectApi, "getDemandCollectOfferData", requestTaskData).then(
        (res) => {
          _this.agentInfo = res.self_public_agent_info;
          _this.codeurl=_this.agentInfo.agent_remark_010;
          _this.testCodeurl=_this.agentInfo.agent_remark_012;
          let orderList = res.page_content;
          if (orderList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          _this.orderList.push(...orderList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          _this.isRequesting = false;
          _this.orderList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    getUIDemandList: function () {
      let _this = this;
      let requestTaskData = {
        isloading: true,
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        mid_table_remark_001:this.search_value,
        mid_table_remark_013:'1301,1302,1303',
        id_public_user_info: _this.userInfo.id_public_user_info,
        is_online:'0,1',
        pre_db_para_order_by_para:' id_public_middle_table desc '
      };
      pageCommon.apiRequestCommon(UIDemandApi, "getUIDemandOfferData", requestTaskData).then(
        (res) => {
          _this.agentInfo = res.self_public_agent_info;
          _this.codeurl=_this.agentInfo.agent_remark_010;
          _this.testCodeurl=_this.agentInfo.agent_remark_012;
          let orderList = res.page_content;
          if (orderList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          _this.orderList.push(...orderList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          _this.isRequesting = false;
          _this.orderList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    getTestDemandList: function () {
      let _this = this;
      let requestTaskData = {
        isloading: true,
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        mid_table_remark_001:this.search_value,
        mid_table_remark_013:'1301,1302,1303',
        id_public_user_info: _this.userInfo.id_public_user_info,
        is_online:'0,1',
        pre_db_para_order_by_para:' id_public_middle_table desc '
      };
      pageCommon.apiRequestCommon(testDemandApi, "getTestDemandOfferData", requestTaskData).then(
        (res) => {
          _this.agentInfo = res.self_public_agent_info;
          _this.codeurl=_this.agentInfo.agent_remark_010;
          _this.testCodeurl=_this.agentInfo.agent_remark_012;
          let orderList = res.page_content;
          if (orderList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          _this.orderList.push(...orderList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          _this.isRequesting = false;
          _this.orderList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    downloadTaskZip(idx){
      let _this = this;
      let requestData = {
        isloading: true,
        id_public_middle_table: this.orderList[idx].mid_table_remark_004
      };
      pageCommon.apiRequestCommon(taskApi, "getAllTaskData", requestData).then(
        (res) => {
          if(res.result_num>0){
            if(res.page_content[0].mid_table_remark_015){
              window.open(res.page_content[0].mid_table_remark_015)
            } else {
              this.$message.error("此任务没有任务包，请联系工作人员解决");
            }
          } else {
            this.$message.error("此任务已下线，请联系工作人员");
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    downloadReviewZip(idx){
      if(!this.orderList[idx].mid_table_remark_011){
        return
      }
      window.open(this.orderList[idx].mid_table_remark_011)
    },
    downloadPublicityZip(idx){
      let _this = this;
      let requestData = {
        isloading: true,
        id_public_middle_table: this.orderList[idx].mid_table_remark_013
      };
      pageCommon.apiRequestCommon(publicityApi, "getPublicityData", requestData).then(
        (res) => {
          if(res.result_num>0){
            if(res.page_content[0].mid_table_remark_012){
              window.open(res.page_content[0].mid_table_remark_012)
            } else {
              this.$message.error("此任务没有任务文件，请联系工作人员解决");
            }
          } else {
            this.$message.error("此任务已下线，请联系工作人员");
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    downloadDemandZip(idx){
      let _this = this;
      let requestData = {
        isloading: true,
        id_public_middle_table: this.orderList[idx].mid_table_remark_008
      };
      pageCommon.apiRequestCommon(demandCollectApi, "getDemandCollectData", requestData).then(
        (res) => {
          if(res.result_num>0){
            if(res.page_content[0].mid_table_remark_007){
              window.open(res.page_content[0].mid_table_remark_007)
            } else {
              this.$message.error("此任务没有任务文件，请联系工作人员解决");
            }
          } else {
            this.$message.error("此任务已下线，请联系工作人员");
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    downloadUIDemandZip(idx){
      let _this = this;
      let requestData = {
        isloading: true,
        id_public_middle_table: this.orderList[idx].mid_table_remark_008
      };
      pageCommon.apiRequestCommon(UIDemandApi, "getUIDemandData", requestData).then(
        (res) => {
          if(res.result_num>0){
            if(res.page_content[0].mid_table_remark_005){
              window.open(res.page_content[0].mid_table_remark_005)
            } else {
              this.$message.error("此任务没有任务文件，请联系工作人员解决");
            }
          } else {
            this.$message.error("此任务已下线，请联系工作人员");
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    downloadTestDemandZip(idx){
      let _this = this;
      let requestData = {
        isloading: true,
        id_public_middle_table: this.orderList[idx].mid_table_remark_008
      };
      pageCommon.apiRequestCommon(testDemandApi, "getTestDemandData", requestData).then(
        (res) => {
          if(res.result_num>0){
            if(res.page_content[0].mid_table_remark_005){
              window.open(res.page_content[0].mid_table_remark_005)
            } else {
              this.$message.error("此任务没有任务文件，请联系工作人员解决");
            }
          } else {
            this.$message.error("此任务已下线，请联系工作人员");
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    downloadPublicityReviewZip(idx){
      if(!this.orderList[idx].mid_table_remark_020){
        return
      }
      window.open(this.orderList[idx].mid_table_remark_020)
    },
    downloadDemandDraftZip(idx){
      if(!this.orderList[idx].mid_table_remark_015){
        return
      }
      window.open(this.orderList[idx].mid_table_remark_015)
    },
    downloadDemandCodeZip(idx){
      if(!this.orderList[idx].mid_table_remark_016){
        return
      }
      window.open(this.orderList[idx].mid_table_remark_016)
    },
    downloadUIFinishZip(idx){
      if(!this.orderList[idx].mid_table_remark_005){
        return
      }
      window.open(this.orderList[idx].mid_table_remark_005)
    },
    handleChange: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_009: 9002,
            mid_table_remark_011: res,
            mid_table_remark_013: 1304,
            time_4_begin: formatDate(new Date(),"YYYY-MM-DD hh:mm:ss")
          }
          let requestTaskData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].mid_table_remark_004,
            mid_table_remark_013: 1304,
          }
          pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              pageCommon.apiRequestCommon(taskApi, "insertTaskData", requestTaskData).then(
                (res) => {
                  _this.$message.success("上传成功");
                  this.$set(this.orderList,idx,newData)
                },
                (err) => {
                }
              )
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handlePublicityChange: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_020: res,
            mid_table_remark_021: 2102,
          }
          pageCommon.apiRequestCommon(publicityApi, "insertPublicityOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              _this.$message.success("上传成功");
              this.$set(this.orderList,idx,newData)
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleUpload: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_014: res,
            mid_table_remark_016: 1601,
          }
          pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              _this.$message.success("上传成功");
              this.$set(this.orderList,idx,newData)
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleUploadCode: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_019: res,
            mid_table_remark_022: 2201,
          }
          pageCommon.apiRequestCommon(demandCollectApi, "insertDemandCollectOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              _this.$message.success("上传成功");
              this.$set(this.orderList,idx,newData)
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleUploadUICode: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_019: res,
            mid_table_remark_021: 2101,
          }
          pageCommon.apiRequestCommon(UIDemandApi, "insertUIDemandOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              _this.$message.success("上传成功");
              this.$set(this.orderList,idx,newData)
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleDraftChange: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_015: res,
            mid_table_remark_017: 1702,
          }
          pageCommon.apiRequestCommon(demandCollectApi, "insertDemandCollectOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              _this.$message.success("上传成功");
              this.$set(this.orderList,idx,newData)
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleDemandCodeChange: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_016: res,
            mid_table_remark_017: 1704,
          }
          pageCommon.apiRequestCommon(demandCollectApi, "insertDemandCollectOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              _this.$message.success("上传成功");
              this.$set(this.orderList,idx,newData)
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleUIChange: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_015: res,
            mid_table_remark_016: 1602,
          }
          pageCommon.apiRequestCommon(UIDemandApi, "insertUIDemandOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              _this.$message.success("上传成功");
              this.$set(this.orderList,idx,newData)
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    loadMoreData: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting=true;
      _this.currentPage += 1;
      if(_this.selTabIndex==100001){
        _this.getGotList();
      }else{
        _this.getOrderList();
      }
    },
    revokeAll(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经中标的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_007:7003
        }
        let requestOnlineData = {
          isloading: true,
          pre_db_para_mid_table_remark_004: this.orderList[idx].mid_table_remark_004,
          pre_db_para_is_online: 0,
          id_public_middle_table: -1,
          is_online: 1
        }
        let requestTaskData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].mid_table_remark_004,
          mid_table_remark_013: 1301,
        }
        pageCommon.apiRequestCommon(taskApi, "updateOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            pageCommon.apiRequestCommon(taskApi, "updateOfferData", requestOnlineData).then(
              (res) => {
                pageCommon.apiRequestCommon(taskApi, "insertTaskData", requestTaskData).then(
                  (res) => {
                    this.$set(this.orderList,idx,newData)
                  },
                  (err) => {
                    if (err.sysUserLoginError) {
                      _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    }
                  }
                );
              },
              (err) => {
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                }
              }
            );
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      });      
    },
    revoke(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经提交的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_007:7003
        }
        pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            this.$set(this.orderList,idx,newData)
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      }); 
    },
    revokePublicity(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经提交的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_018:1803
        }
        pageCommon.apiRequestCommon(publicityApi, "insertPublicityOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            this.$set(this.orderList,idx,newData)
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      }); 
    },
    revokeDemandOffer(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经提交的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_013:1303
        }
        pageCommon.apiRequestCommon(demandCollectApi, "insertDemandCollectOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            this.$set(this.orderList,idx,newData)
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      }); 
    },
    revokeDemandAll(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经中标的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_013:1303
        }
        let requestOnlineData = {
          isloading: true,
          pre_db_para_mid_table_remark_008: this.orderList[idx].mid_table_remark_008,
          pre_db_para_is_online: 0,
          id_public_middle_table: -1,
          is_online: 1,
        }
        let requestTaskData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].mid_table_remark_008,
          mid_table_remark_020: 2001,
        }
        pageCommon.apiRequestCommon(demandCollectApi, "insertDemandCollectOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            pageCommon.apiRequestCommon(demandCollectApi, "updateDemandCollectOfferData", requestOnlineData).then(
              (res) => {
                pageCommon.apiRequestCommon(demandCollectApi, "updateDemandCollectData", requestTaskData).then(
                  (res) => {
                    this.$set(this.orderList,idx,newData)
                  },
                  (err) => {
                    if (err.sysUserLoginError) {
                      _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    }
                  }
                );
              },
              (err) => {
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                }
              }
            );
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      });      
    },
    revokeUIDemandOffer(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经提交的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_013:1303
        }
        pageCommon.apiRequestCommon(UIDemandApi, "insertUIDemandOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            this.$set(this.orderList,idx,newData)
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      }); 
    },
    revokeUIDemandAll(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经中标的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_013:1303
        }
        let requestOnlineData = {
          isloading: true,
          pre_db_para_mid_table_remark_008: this.orderList[idx].mid_table_remark_008,
          pre_db_para_is_online: 0,
          id_public_middle_table: -1,
          is_online: 1,
        }
        let requestTaskData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].mid_table_remark_008,
          mid_table_remark_007: 7001,
        }
        pageCommon.apiRequestCommon(UIDemandApi, "insertUIDemandOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            pageCommon.apiRequestCommon(UIDemandApi, "insertUIDemandOfferData", requestOnlineData).then(
              (res) => {
                pageCommon.apiRequestCommon(UIDemandApi, "updateUIDemandData", requestTaskData).then(
                  (res) => {
                    this.$set(this.orderList,idx,newData)
                  },
                  (err) => {
                    if (err.sysUserLoginError) {
                      _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    }
                  }
                );
              },
              (err) => {
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                }
              }
            );
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      });      
    },
    revokeTestDemandOffer(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经提交的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_013:1303
        }
        pageCommon.apiRequestCommon(testDemandApi, "insertTestDemandOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            this.$set(this.orderList,idx,newData)
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      }); 
    },
    revokeTestDemandAll(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经中标的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_013:1303
        }
        let requestOnlineData = {
          isloading: true,
          pre_db_para_mid_table_remark_008: this.orderList[idx].mid_table_remark_008,
          pre_db_para_is_online: 0,
          id_public_middle_table: -1,
          is_online: 1,
        }
        let requestTaskData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].mid_table_remark_008,
          mid_table_remark_007: 7001,
        }
        pageCommon.apiRequestCommon(testDemandApi, "insertTestDemandOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            pageCommon.apiRequestCommon(testDemandApi, "insertTestDemandOfferData", requestOnlineData).then(
              (res) => {
                pageCommon.apiRequestCommon(testDemandApi, "updateTestDemandData", requestTaskData).then(
                  (res) => {
                    this.$set(this.orderList,idx,newData)
                  },
                  (err) => {
                    if (err.sysUserLoginError) {
                      _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    }
                  }
                );
              },
              (err) => {
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                }
              }
            );
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      });      
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.ordercenter {
  position: relative;
  width: 100%;
  // height: 100%;
  height: 1131px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .page-title-wrap{
      display: flex;
      flex-direction: row;
    }
    .search-wrap{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-left:24px;
      width: 312px;
      height: 36px;
      padding: 0 0 0 13px;
      border: 1px solid #EAEAEA;
      border-radius: 4px;
      .icon-text{
        display:block;
        width:270px;
        height:36px;
        line-height:1.2em;
        font-size:.69rem;
        border:none;
        background:transparent;
        outline: none;
        &::placeholder{
          color:#AAA;
        }
      }
      .icon-serch{
        display: block;
        width:36px;
        height:36px;
        background-size:44.44%;
        background-position:center;
        background-repeat:no-repeat;
        background-image:url(~@/assets/icon_search.png);
      }
    }
  }
  .nav-tabpanel-box {
    position: relative;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    margin-top: 40px;
    .item-nav-box {
      position: relative;
      height: 32px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      color: #222222;
      line-height: 18px;

      box-sizing: border-box;
      cursor: pointer;
      margin-right: 64px;
      &.active {
        color: #ec4040;
        font-weight: bold;
        &::after {
          position: absolute;
          width: 100%;
          content: "";
          height: 4px;
          background: #ec4040;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
    // margin-right: 20px;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .offername{
    width: 130px;
    text-align: left;
  }
  .offertype{
    width: 130px;
    text-align: center;
  }
  .offermoney{
    width: 130px;
    text-align: center;
  }
  .offertime{
    width: 198px;
    text-align: center;
  }
  .offerHandle{
    width: 350px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .handleItem{
      text-align:center;
      &.width100{
        width:120px;
      }
      &.width85{
        width:103px;
      }
      &.width45{
        width:45px;
      }
      &.red{
        color: #ec4040;
        cursor:pointer;
      }
      &.pink{
        color:#FFA8A8;
        cursor:normal;
      }
    }
  }
  .collectHandle{
    width: 600px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .handleItem{
      text-align:center;
      &.width120{
        width:120px;
      }
      &.width85{
        width:103px;
      }
      &.width45{
        width:45px;
      }
      &.red{
        color: #ec4040;
        cursor:pointer;
      }
      &.pink{
        color:#FFA8A8;
        cursor:normal;
      }
    }
  }
  .ordertype {
    width: 116px;
    text-align: left;
  }
  .orderpaytype {
    width: 114px;
    text-align: center;
  }
  .paytime {
    width: 198px;
    text-align: center;
  }
  .couponmoney {
    width: 124px;
    text-align: center;
  }
  .surplusmoney {
    width: 137px;
    text-align: center;
  }
  .realpay {
    width: 142px;
    text-align: center;
  }
  .orderstatus {
    width: 98px;
    text-align: right;
  }
  .distributionid {
    width: 141px;
    text-align: left;
  }
  .avatar {
    width: 42px;
    text-align: center;
    .user-avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }
  }
  .username {
    width: 162px;
    text-align: center;
  }
  .userphone {
    width: 153px;
    text-align: center;
  }
  .distributionordertype {
    width: 141px;
    text-align: center;
  }
  .distributionmoney {
    width: 155px;
    text-align: center;
  }
  .fanyongmoney {
    width: 131px;
    text-align: right;
  }
  .table-header-box {
    position: relative;
    align-items: baseline;
    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 36px;
    margin-bottom: 20px;
    align-items: center;
    &.recharge {
      align-items: center;
      // padding-top: 18px;
    }
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
    &.distribution {
      width: 100%;
      padding-left: 25px;
      padding-right: 15px;
      box-sizing: border-box;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    position: relative;
    height: 120px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 25px;

    &:last-child {
      margin-bottom: 0;
    }
    .order-num-box {
      position: relative;
      width: 988px;
      height: 40px;
      background: #f4f4f4;
      border-radius: 4px 4px 0px 0px;
      box-sizing: border-box;
      margin: 0 auto;
      padding-left: 24px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-align: left;
      .order-num {
        padding-left: 10px;
      }
      .distribute-paytime {
        padding-left: 24px;
      }
    }
    .offer-num-box{
      position: relative;
      width: 988px;
      height: 40px;
      background: #f4f4f4;
      border-radius: 4px 4px 0px 0px;
      box-sizing: border-box;
      margin: 0 auto;
      padding:0 28px 0 24px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-align: left;
      display:flex;
      justify-content: space-between;
      .offer-content-box{
        display:flex;
        .upload-code{
          margin-left:15px;
        }
      }
      .upload-code{
        color: #0072FF;
      }
    }
    .cell-row {
      margin-top: 31px;
    }
    &.distribution {
      .cell-row {
        margin-top: 18px;
        padding-right: 15px;
      }
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      &.color9001{
        color: #ff9e13;
      }
      &.color9002{
        color: #0072ff;
      }
      &.color9003{
        color: #208227;
      }
      &.color9004{
        color: #e62c17;
      }
      &.red{
        color: #ec4040;
        font-weight: bolder;
        cursor:pointer;
      }
      &.gray{
        color:#878787;
        cursor:normal;
      }
    }
    .couponmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .surplusmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .realpay {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #000000;
      &.red{
        color: #ec4040;
      }
    }
    .fanyongmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
  }
}
</style>
<style lang="less">
.el-tooltip__popper.code-custom-tooltip{
  border:none;
  box-shadow: 0px 3px 38px 0px rgba(58,58,58,0.1);
  border-radius: 4px;
  .popper__arrow{
    border:none;
  }
}
.code-tooltip-inner{
  padding:16px 18px 18px 18px;
  width:204px;
  height:230px;
  background:#FFF;
  .code-tooltip-inner-title{
    margin-bottom:12px;
    font-size: 16px;
    font-weight: bolder;
    color: #222;
    text-align:center;
  }
  .code-tooltip-inner-img-wrap{
    width:168px;
    height:168px;
    padding:14px;
    background-size:100%;
    background-position:center;
    background-repeat:no-repeat;
    background-image:url(~@/assets/bg-qrcode.png);
    .code-tooltip-inner-img{
      width:100%;
      height:100%;
    }
  }
}
</style>
